import { render } from "./TenWeekPicks.vue?vue&type=template&id=336979ca"
import script from "./TenWeekPicks.vue?vue&type=script&lang=ts"
export * from "./TenWeekPicks.vue?vue&type=script&lang=ts"
script.render = render

export default script